// Map of user IDs to band member names
const userNameMapping = {
  // Real band member mappings - include variations of email formats
  'danny@cloudbloke.com': 'Danny',
  'joey.allison@hotmail.co.uk': 'Joe',
  'stevo_chambers@hotmail.com': 'Stevo',
  'him@itsverydan.co.uk': 'Dan',
  // Add a default case for unknown users
  'default': 'Band Member'
};

/**
 * Get the display name for a user ID
 * @param {string} userId - The user ID to look up
 * @returns {string} - The display name for the user
 */
export const getUserDisplayName = (userId) => {
  if (!userId) return userNameMapping.default;
  
  // Log the user ID for debugging
  console.log('Looking up display name for user ID:', userId);
  
  // Try direct match first
  if (userNameMapping[userId]) {
    return userNameMapping[userId];
  }
  
  // Try case-insensitive match
  const lowerCaseId = userId.toLowerCase();
  for (const [mappedId, name] of Object.entries(userNameMapping)) {
    if (mappedId.toLowerCase() === lowerCaseId) {
      return name;
    }
  }
  
  // Try matching just the part before @ in email
  if (userId.includes('@')) {
    const localPart = userId.split('@')[0].toLowerCase();
    
    if (localPart === 'danny') return 'Danny';
    if (localPart === 'joey.allison') return 'Joe';
    if (localPart === 'stevo_chambers') return 'Stevo';
    if (localPart === 'him') return 'Dan';
  }
  
  return userNameMapping.default;
};

export default userNameMapping;
